import { EmailManagementSettings, LastRefreshResponse, PmsSyncStatus } from '@anduin/api';
import { DEFAULT_LOADABLE_STATE, Loadable, LoadableStatus } from '@anduin/shared';
import { MetricUnit } from '../models/metric-unit.model';
import { EmailDeliveryTab } from '../models/email-delivery-tab.enum';
import {
  EmailDeliveryHubFailedFilters,
  EmailDeliveryHubPendingFilters,
  EmailDeliveryHubSentFilters,
} from '../models/email-delivery-hub-filters.models';

export enum PmsSyncPollingState {
  IDLE = 'idle',
  POLLING = 'polling',
  SYNCED = 'synced',
  UNCONFIRMED = 'unconfirmed',
  ERROR = 'error',
}

export interface EmailDeliveryHubSentMetrics {
  total: MetricUnit;
  bounced: number;
  metricUnits: MetricUnit[];
  comparisonDateRange?: string;
}

export interface EmailDeliveryHubModel {
  settings: Loadable<EmailManagementSettings>;

  sentFilters: Loadable<Partial<EmailDeliveryHubSentFilters>>;
  pendingFilters: Loadable<EmailDeliveryHubPendingFilters>;
  failedFilters: Loadable<EmailDeliveryHubFailedFilters>;

  sentMetrics: Loadable<EmailDeliveryHubSentMetrics>;
  lastRefresh: Loadable<LastRefreshResponse>;

  pmsSyncStatus: Loadable<PmsSyncStatus>;
  pmsSyncPollingState: PmsSyncPollingState;

  activeTab: EmailDeliveryTab;
}

export const EMAIL_DELIVERY_HUB_DEFAULT_STATE: EmailDeliveryHubModel = {
  settings: DEFAULT_LOADABLE_STATE,

  sentFilters: { status: LoadableStatus.LOADING },
  pendingFilters: DEFAULT_LOADABLE_STATE,
  failedFilters: DEFAULT_LOADABLE_STATE,

  sentMetrics: DEFAULT_LOADABLE_STATE,
  lastRefresh: DEFAULT_LOADABLE_STATE,

  pmsSyncStatus: DEFAULT_LOADABLE_STATE,
  pmsSyncPollingState: PmsSyncPollingState.IDLE,

  activeTab: EmailDeliveryTab.SENT,
};
